<template>
    <div class="email_modal" v-if="showPopup">
        <Teleport  to="#teleports">
            <div id="modal-tall" data-bs-backdrop="true" visible ref="modal" class="p-0 modal fade modal-xl " tabindex="-1"
                aria-labelledby="modal-tall" data-bs-tar aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content p-lg-4">
                        <div class="modal-body">
                            <div>
                                <div class="title_close">
                                    <div class="title_here font-active">Create Your Own {{ module }}</div>
                                    <div class="close_btn"><span @click="hideModal">
                                            <SvgHeaderSvg :type="'close'" class="largesvg"/>
                                        </span></div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-lg-4">
                                        <div class="pop_box">
                                            <h3 class="font-active">1</h3>
                                            <div class="pop_sub_box" v-if="module === 'ring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyor_setting.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Ring Setting image"
                                                        src="@/assets/cyo_popup/cyor_setting.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose a Setting</h4>
                                                <p class="mb-0">Explore our engagement ring settings, offering 5 distinct
                                                    styles and
                                                    various metal options.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'earring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyoe_setting.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Earrings Setting Image"
                                                        src="@/assets/cyo_popup/cyoe_setting.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose a Setting</h4>
                                                <p class="mb-0">Browse through our curated earring designs, showcasing an
                                                    array of
                                                    styles suitable for any occasion.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'pendant'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyop_setting.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Pendant Setting Image"
                                                        src="@/assets/cyo_popup/cyop_setting.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose a Setting</h4>
                                                <p class="mb-0">Explore our pendant designs, featuring a diverse range of
                                                    styles &
                                                    metal
                                                    options to suit your preferences.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <div class="pop_box">
                                            <h3 class="font-active">2</h3>
                                            <div class="pop_sub_box" v-if="module === 'ring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyor_diamond.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Ring Setting Diamond"
                                                        src="@/assets/cyo_popup/cyor_diamond.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose a Diamond</h4>
                                                <p class="mb-0"> Choose from our collection of over 70,000+
                                                    ethically-sourced &
                                                    affordably priced certified lab diamonds.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'earring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyoe_diamond.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Earring Setting Diamond"
                                                        src="@/assets/cyo_popup/cyoe_diamond.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose Your Diamonds</h4>
                                                <p class="mb-0">Indulge in our selection of 70,000+ responsibly-sourced &
                                                    certified
                                                    lab
                                                    diamonds, each with its unique qualities.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'pendant'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyop_diamond.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Choose a Pendant Setting Diamond"
                                                        src="@/assets/cyo_popup/cyop_diamond.jpg" />
                                                </picture>
                                                <h4 class="font-active">Choose a Diamond</h4>
                                                <p class="mb-0"> Discover from our 70,000+ ethically-sourced & certified lab
                                                    diamonds,
                                                    each radiating its unique brilliance.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <div class="pop_box">
                                            <h3 class="font-active">3</h3>
                                            <div class="pop_sub_box" v-if="module === 'ring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyor.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Complete Your Ring Image" src="@/assets/cyo_popup/cyor.jpg" />
                                                </picture>
                                                <h4 class="font-active">Complete Your Ring!</h4>
                                                <p class="mb-0">Add the finishing touch by choosing your ring size, adding a
                                                    unique
                                                    matching band & getting it engraved.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'earring'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyoe.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Complete Your Earring Image"
                                                        src="@/assets/cyo_popup/cyoe.jpg" />
                                                </picture>
                                                <h4 class="font-active">Complete Your Earring!</h4>
                                                <p class="mb-0">Tailor your earrings to perfection by deciding on the
                                                    earring back
                                                    type
                                                    for full comfort and security.</p>
                                            </div>
                                            <div class="pop_sub_box" v-if="module === 'pendant'">
                                                <picture>
                                                    <source width="200" height="200" type="image/webp"
                                                        srcset="@/assets/cyo_popup/cyop.webp">
                                                    <img loading="lazy" type="image/jpeg" fluid width="200" height="200"
                                                        alt="Complete Your Pendant Image"
                                                        src="@/assets/cyo_popup/cyop.jpg" />
                                                </picture>
                                                <h4 class="font-active">Complete Your Pendant!</h4>
                                                <p class="mb-0">Add a personal touch by choosing the chain length for your
                                                    pendant
                                                    that
                                                    complements your style.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text_bottom" v-if="module === 'ring'">
                                    Looking for inspiration? Browse through our <router-link
                                        :to="localePath('/engagement-ring-for-women')">customers’ creations.</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Teleport>

    </div>
</template>

<script setup>
import { popupStore } from '@/stores/popup/popup';

const store = popupStore()
const localePath = useLocalePath()

const props = defineProps({
    module: String
})

const showPopup = ref(false)
const modal = ref(null)





onMounted(async () => {
    // const status = await store.getPopupFlag(props.module)

    // if (!status) {
    //     setTimeout(() => { showModal() }, 4000)
    //     store.setPopupFlag(props.module)
    // }



    
})

const showModal = () => {
    showPopup.value = true;
    nextTick(() => {
        const modalElement = modal.value;
        if (modalElement) {
            const modalInstance = new bootstrap.Modal(modalElement);
            modalInstance.show();
        }
    });
};


const hideModal = () => {
    const modalElement = modal.value;
    if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    }
    showPopup.value = false;
};


</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
}
.title_close {
    text-align: center;
    font-size: 30px;
    color: var(--green);
    letter-spacing: 0.5px;
    margin-bottom: 25px;
    position: relative;
    text-transform: capitalize;
}

.close_btn {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
}

h3 {
    text-align: center;
    font-size: 70px;
    color: var(--green);
}

.pop_sub_box {
    text-align: center;
    border-bottom: 5px solid #f5f5f5;
    border-left: 2px solid #f5f5f5;
    border-radius: 15px;
    border-top: 0;
    padding: 0 20px 25px 20px;
    border-right: 2px solid #f5f5f5;
}

h4 {
    font-size: 20px;
}

p {
    color: #606060;
    font-size: 16px;
}

.text_bottom {
    text-align: center;
    font-size: 16px;
    color: #606060;
    padding-top: 25px;
}

.text_bottom a {
    text-decoration: underline;
}

@media(max-width: 1200px) {
    .pop_sub_box {
        padding: 0 10px 25px 10px;
    }

    .title_close {
        font-size: 24px;
    }

    h3 {
        font-size: 52px;
    }

    h4 {
        font-size: 17px;
    }

    p {
        font-size: 14px;
    }
}

@media(max-width: 992px) {
    .title_close {
        font-size: 18px;
    }

    .pop_box {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 6px solid #f5f5f5;
        border-left: 2px solid #f5f5f5;
        border-radius: 10px;
        border-top: 0;
        padding: 10px;
        border-right: 2px solid #f5f5f5;
        margin-bottom: 25px;
    }

    h3 {
        font-size: 40px;
        width: 20%;
    }

    .pop_sub_box {
        display: flex;
        align-items: center;
        width: 80%;
    }

    p {
        display: none;
    }

    .pop_sub_box {
        border: 0;
        padding: 0;
    }

    .pop_sub_box img {
        max-width: 100px;
    }

    h4 {
        font-size: 16px;
        width: inherit;
    }
}

@media(max-width: 767px) {
    h4 {
        font-size: 14px;
        text-align: left;
        padding-left: 15px
    }

    h3 {
        font-size: 30px;
        width: 15%;
    }

    .pop_sub_box img {
        max-width: 70px;
    }

    .pop_box {
        border-bottom: 5px solid #f5f5f5;
        border-left: 2px solid #f5f5f5;
        border-radius: 5px;
        border-top: 0;
        padding: 10px;
        border-right: 2px solid #f5f5f5;
        margin-bottom: 16px;
    }

    .text_bottom {
        padding-top: 10px;
    }

    .close_btn {
        position: absolute;
        right: -15px;
        top: -20px;
        cursor: pointer;
    }
}
</style>
